<template>
<div class="app-shell">
  <Menubar></Menubar>
  <div class="ui padded grid">
    <router-view></router-view>
  </div>
</div>
</template>

<script>
import Menubar from './Menubar.vue';
export default {
  name: 'app',
  components: {Menubar}
}
</script>

<style scoped>
.app-shell {
    display: flex;
    flex-direction: column;
}
.ui.grid {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/App.vue